import React, { useState } from "react";
import { Box, Button, MenuItem, Stack, TextField } from "@mui/material";
import adminApi from "../../api/adminApi";
import { ROLE_OPTIONS } from "../../constants/adminConstants";

const FIELD_SX = {
  "& .MuiInputBase-root": {
    height: 40,
  },
};

export default function CreateUserForm({ onCreated, setBanner }) {
  const [form, setForm] = useState({
    firstname: "",
    lastname: "",
    email: "",
    password: "",
    role: "USER",
  });
  const [saving, setSaving] = useState(false);

  const updateField = (field) => (event) => {
    setForm((prev) => ({ ...prev, [field]: event.target.value }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setSaving(true);

    try {
      await adminApi.registerUser(form);
      setBanner({ type: "success", text: `Created user ${form.email}` });
      setForm({
        firstname: "",
        lastname: "",
        email: "",
        password: "",
        role: "USER",
      });
      onCreated?.();
    } catch (error) {
      setBanner({ type: "error", text: error.message || "Failed to create user" });
    } finally {
      setSaving(false);
    }
  };

  return (
    <Box component="form" onSubmit={handleSubmit}>
      <Stack direction={{ xs: "column", md: "row" }} spacing={2} useFlexGap flexWrap="wrap">
        <TextField
          label="First name"
          value={form.firstname}
          onChange={updateField("firstname")}
          size="small"
          required
          sx={FIELD_SX}
        />
        <TextField
          label="Last name"
          value={form.lastname}
          onChange={updateField("lastname")}
          size="small"
          required
          sx={FIELD_SX}
        />
        <TextField
          label="Email"
          type="email"
          value={form.email}
          onChange={updateField("email")}
          size="small"
          required
          sx={{ ...FIELD_SX, minWidth: 260 }}
        />
        <TextField
          label="Password"
          value={form.password}
          onChange={updateField("password")}
          size="small"
          required
          sx={{ ...FIELD_SX, minWidth: 220 }}
        />
        <TextField
          select
          label="Role"
          value={form.role}
          onChange={updateField("role")}
          size="small"
          sx={{ ...FIELD_SX, minWidth: 140 }}
        >
          {ROLE_OPTIONS.map((role) => (
            <MenuItem key={role} value={role}>
              {role}
            </MenuItem>
          ))}
        </TextField>
        <Button
          type="submit"
          variant="contained"
          disabled={saving}
          sx={{ height: 40, minWidth: 140 }}
        >
          {saving ? "Creating..." : "Create user"}
        </Button>
      </Stack>
    </Box>
  );
}